/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Fit_2Inputs */

const en_pc_alt_fit_2 = /** @type {(inputs: Pc_Alt_Fit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You organize, combine, split or extract pages and want links, form fields and bookmarks to survive.`)
};

const zh_pc_alt_fit_2 = /** @type {(inputs: Pc_Alt_Fit_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你需要整理、合并、拆分或提取页面，并希望链接、表单字段和书签都能保留。`)
};

/**
* | output |
* | --- |
* | "You organize, combine, split or extract pages and want links, form fields and bookmarks to survive." |
*
* @param {Pc_Alt_Fit_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_fit_2 = /** @type {((inputs?: Pc_Alt_Fit_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Fit_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_fit_2(inputs)
	return zh_pc_alt_fit_2(inputs)
});
export { pc_alt_fit_2 as "pc.alt.fit.2" }